module.exports = __webpack_public_path__ + "img/icon_pointcomplete.d869b6c8.svg";